import { Box, TextField } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { EditIconTwoTone } from '@room-match/shared-ui-components';
import { CustomTextField } from '../FieldContent/FieldContent.styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useStyles } from './DisplayField.styles';
const DisplayField = ({ baseUrl, setIsEditing }: { baseUrl: string; setIsEditing: Function }) => {
  const classes = useStyles();
  return (
    <Box>
      <CustomTextField
        variant="outlined"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <EditIconTwoTone
                onClick={() => setIsEditing((prev: boolean) => !prev)}
                fontSize="small"
                style={{ color: COLORS.PRIMARY, cursor: 'pointer' }}
              />
            </InputAdornment>
          ),
        }}
        value={baseUrl}
        className={classes.input}
        disabled
        fullWidth
      />
    </Box>
  );
};

export default DisplayField;
